function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mergeStyleSets } from '@uifabric/styling';
import { ActionButton, DatePicker as FabricDatePicker } from 'office-ui-fabric-react';
import { clearIconButtonStyles } from '../ClearIconButtonStyles';
import { ActionIconName, Icon } from '../Icons';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ClearableDatePicker = props => {
  const clearButtonStyles = mergeStyleSets(clearIconButtonStyles, {
    root: {
      marginRight: 3
    }
  });
  const getTextFieldButton = suffixProps => /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!props.value && /*#__PURE__*/_jsx(ActionButton, {
      disabled: props.disabled,
      iconProps: {
        iconName: ActionIconName.Close
      },
      styles: clearButtonStyles,
      "data-is-focusable": false,
      onClick: props.onClearClick
    }), /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, suffixProps), {}, {
      iconName: "Calendar",
      styles: {
        root: {
          cursor: 'pointer',
          fontSize: 16
        }
      },
      onClick: event => {
        (suffixProps === null || suffixProps === void 0 ? void 0 : suffixProps.onClick) && suffixProps.onClick(event);
        props.onCalendarIconClick && props.onCalendarIconClick();
      }
    }))]
  });
  return /*#__PURE__*/_jsx(FabricDatePicker, _objectSpread(_objectSpread({}, props), {}, {
    "data-id": props.dataId,
    textField: {
      onRenderSuffix: getTextFieldButton,
      styles: {
        suffix: {
          backgroundColor: 'transparent'
        },
        root: {
          width: '100%'
        }
      },
      iconProps: {
        styles: {
          root: {
            display: 'none'
          }
        }
      }
    },
    styles: _objectSpread(_objectSpread({}, props.styles), {}, {
      callout: {
        selectors: {
          // Be wary of this styling hack: https://stackoverflow.com/a/60310536/479836
          // It's here as a temporary fix for this Github issue: https://github.com/microsoft/fluentui/issues/13991
          '& .ms-DatePicker-goToday': {
            right: '0px'
          }
        }
      }
    })
  }));
};